/** Strips the trailing instance suffix `_$N` from an array field id. */
export const getBaseFieldId = (fieldId: string): string =>
  fieldId.replace(/_\$\d+$/, '');
